import { __, T } from '../translations/i18n'
import { CustomTmrItem } from '../api/types'
import styled from '@emotion/styled'
import { Box, Image } from './index'

export default class QualityProvider {

  static getItemMessage = (item: CustomTmrItem) => {
    const messages: string[] = []
    if (item.states?.find((state) => state === 'ITEM_NOT_IN_INBOUND')) {
      messages.push(__(T.error.item_not_in_inbound))
    }
    if (item.states?.find((state) => state === 'ITEM_NOT_IN_STOCK')) {
      messages.push(__(T.error.item_not_in_stock))
    }
    if (item.states?.find((state) => state === 'ITEM_IN_ANOTHER_PARCEL')) {
      messages.push(__(T.error.item_in_another_parcel))
    }
    if (item.states?.find((state) => state === 'ITEM_IN_ANOTHER_PRODUCTION_ORDER')) {
      messages.push(__(T.error.item_in_another_production_order))
    }
    if (messages.length === 0) return undefined

    return messages.join()
  }
}

export const Row = styled(Box)`
  margin-bottom: 20px;
  border: 2px solid #edecec;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
`

export const Separator = styled.div`
  width: 2px;
  height: 100%;
  background-color: #edecec;
`

export const ProductImage = styled(Image)`
  width: 100px;
  height: 100px;
  padding: 10px;
`

export const ProductCode = styled.div`
  font-weight: 900;
  font-size: 28px;
`

export const ItemEpc = styled.div`
  font-weight: 400;
  font-size: 20px;
`

export const Message = styled.div<{ status?: 'error' | 'warning' }>`
  font-weight: 400;
  font-size: 20px;
  color: ${({ status }) => {
  switch (status) {
    case 'warning':
      return '#FBBF66'
    case 'error':
      return '#FD7575'
    default:
      return '#454545'
  }
}};
`
